import React from 'react'
import PropTypes from 'prop-types'
import SideMenu from './SideMenu'
import UserOptions from './UserOptions'
import AppsSelect from './AppsSelect'
import { FlexView } from '../../common'
import styled from 'styled-components'
import LanguageSelect from 'containers/common/LanguageSelect'
import HomeIcon from './HomeIcon'



const LeftSide = styled(FlexView)`
  *:first-child {
    margin-left: 0px !important;
  }
`

const RightSide = styled(FlexView)`
  *:last-child {
    margin-right: 0px !important;
  }
`

const CustomFlexView = styled(FlexView)`
min-height: 50px;
`

const WarningBanner = styled.div`
  width: 100%;
  background-color: #ffe066;
  color: #303030;
  padding: 8px 16px;
  box-sizing: border-box;
  text-align: center;
  border-bottom: 1px solid #f0cd2f;
`

const WarningLine = styled.p`
  margin: 0;
  font-family: "Roboto";
  font-size: 13px;
  line-height: 18px;
`

const WarningLineBold = styled(WarningLine)`
  font-weight: bold;
`

const WarningLink = styled.a`
  color: #303030;
  text-decoration: underline;
  font-weight: bold;
`

const Header = ({ title, sideMenuSettings, appIconSrc, onAppIconClick, apps, userSettings, homeIcon, warningLink, warningTopText, warningLinkText, warningBottomText }) =>
  <React.Fragment>
    <WarningBanner>
      <WarningLineBold>
        {warningTopText}
        <WarningLink href={warningLink} target="_blank" rel="noopener noreferrer">{warningLinkText}</WarningLink>.
      </WarningLineBold>
      <WarningLine>
        {warningBottomText}
      </WarningLine>
    </WarningBanner>
    <CustomFlexView height="50px" width="calc(100% - 32px)" padding="10px 16px" flexDirection="row" justifyContent="space-between"
      alignItems="stretch" elevation="low">
      <LeftSide flexDirection="row" justifyContent="flex-start" alignItems="center">
        {sideMenuSettings && <SideMenu {...sideMenuSettings} />}
        {homeIcon && <HomeIcon {...homeIcon} />}
        <FlexView fontSize="big" fontWeight="bold" margin="0px 12px 0px" color="gray" flexDirection="row" alignItems="center">
          {title}
        </FlexView>
      </LeftSide>
      <RightSide flexDirection="row" justifyContent="flex-end" alignItems="center">
        <LanguageSelect margin="0px 16px" fontSize="small" noLabel noWrapper />
        {apps && <AppsSelect apps={apps} />}
        {userSettings && <UserOptions {...userSettings} />}
      </RightSide>
    </CustomFlexView>
  </React.Fragment>

Header.propTypes = {
  /**
   * The title that will appear on the header
   */
  title: PropTypes.node.isRequired,
  /**
   * The application icon source, positioned to the left of the title
   */
  appIconSrc: PropTypes.any,
  /**
   * Function called when the application icon is clicked, normally redirecting to the home page
   */
  onAppIconClick: PropTypes.func,
  /**
   * Side menu settings. Object composed of the application logo source and item groups that will form the side menu entries
   */
  sideMenuSettings: PropTypes.shape({
    appLogoSrc: PropTypes.any,
    itemGroups: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        iconSrc: PropTypes.string,
        onClick: PropTypes.func,
      }))
    }))
  }),
  /**
   * Array of configuration objects to render the applications tooltip
   */
  apps: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconSrc: PropTypes.any.isRequired,
    onClick: PropTypes.func,
  })),
  /**
   * Side menu settings. Object composed of the application logo source and item groups that will form the side menu entries
   */
  userSettings: PropTypes.shape({
    username: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      divider: PropTypes.bool
    }))
  }),
  /**
   * URL used by the warning banner links
   */
  warningLink: PropTypes.string,
  warningTopText: PropTypes.string,
  warningLinkText: PropTypes.string,
  warningBottomText: PropTypes.string
}

Header.defaultProps = {
  warningLink: '#',
  warningTopText: '',
  warningLinkText: '',
  warningBottomText: ''
}

export default Header